import React from 'react'
import { Typography } from '@mui/material'
import {
  IMAGE_BASE_PATH_DBRALC,
  IMAGE_BASE_PATH_COMMON,
} from '../../Config/Config'

const MVComponent = ({ getdata }) => {
  const data = getdata
  return (
    <section className="container mt-5">
      <div className="text-center py-5">
        <img
          src={
            data.image_url === ''
              ? IMAGE_BASE_PATH_COMMON + 'Placeholders/Placeholder_Image.jpg'
              : IMAGE_BASE_PATH_DBRALC + data.image_url
          }
          height={'auto'}
          className="w-25"
          alt="MV-Data"
          loading="lazy"
          placeholder="blur"
        />
        <Typography variant="h5" className="text-center mt-4">
          {data.content_type}
        </Typography>
        <Typography
          variant="body1"
          className="multine-ellipsis-4 body1_color  mt-3"
        >
          {data.content}
        </Typography>
      </div>
    </section>
  )
}

export default MVComponent
